<app-selector label="Mario Game" [isEmptySelectable]="isEmptySelectable" [data]="marioGameCoreService.marioGameList$| async" displayKey="name" [formControl]="ctrl"
    (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="marioGameCoreService.loading" [hint]="hint">
</app-selector>